import React, { useEffect, useRef } from 'react';

import Vulnerability from '../../types/Vulnerability';
import DetailsItem from '../detailsItem/DetailsItem';
import styles from './detailsView.scss';

type Props = {
  id: string;
  vulnerability: Vulnerability;
};

const DetailsView: React.FC<Props> = (props) => {
  // Auto-scroll back to the top when we change vulnerability.
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [props.vulnerability]);

  const renderDetails = () => {
    return Object.entries(props.vulnerability).map(([key, value], index) => {
      return <DetailsItem key={index} id={key} index={index} name={key} info={value} />;
    });
  };

  return (
    <div ref={ref} id={props.id} data-testid={props.id} className={styles['details-panel']}>
      {renderDetails()}
    </div>
  );
};

export default DetailsView;
